
import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';


import SelectMultipleForm from '../../../partials/selectMultiForm'
import { styles } from './styles';


class AddMenuItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuId: this.props.menuId || [],
        }
        this.getData = this.getData.bind(this)
    }
    componentDidMount() {
        this.props.onRef(this);
        this.props.getList()
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.menuId !== this.props.menuId) {
            let menuId = nextProps.menuId !== undefined ? nextProps.menuId : nextProps.listMenuGroup.length ? nextProps.listMenuGroup[0].id : ''
            this.setState({ menuId: menuId })
        }
    }
    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    }
    getData() {
        const {menuId} = this.state;
        let value = JSON.stringify(typeof menuId !== 'string' ? menuId : [menuId])
        return value
    }
    reset() {
        this.setState({ menuId: [] })
    }
    getLabel = (code) => {
        let {listMenuGroup = []} = this.props;
        let name = listMenuGroup.find((menu) => {
            return (code === menu.id)
        })
        return name ? name.name : ""
    }
    handleDeletePhone = (id) => {
        let {menuId} = this.state;
        if(typeof menuId === 'string') {
            menuId = ""
        } else {
            let index = menuId.indexOf(id)
            menuId.splice(index, 1);
        }
        this.setState({ menuId })
    }
    render() {
        let {  t, required, disabled = false, listMenuGroup = []} = this.props;
        const {menuId} = this.state;
        return (
            <SelectMultipleForm
                required={required}
                fullWidth={true}
                label={t('menu_menuitem_addmenuitem_group')}
                multiple={true}
                value={menuId}
                name="menuId"
                select 
                disabled={disabled}
                onChange={this.handleChange}
                list={listMenuGroup.map(e => {
                    return {
                        value: e.id,
                        label: e.name,
                    }
                })}
            /> 
        )
    }
}

AddMenuItem.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};
AddMenuItem.defaultProps = {
    isMulti: true
}
const mapState = state => ({
    listMenuGroup: state.serviceMenu.listMenuGroup,
});

const mapDispatch = dispatch => ({
    getList: dispatch.serviceMenu.getAllMenuGroup
});

export default connect(mapState, mapDispatch)(translate('translations')(withStyles(styles, { withTheme: true })(AddMenuItem)));








